import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/solid.min.css";
import App from "App";
import reportWebVitals from "reportWebVitals";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";

let theme = createTheme({
  typography: {
    fontFamily: `"Montserrat", "Helvetica", "Arial", sans-serif`,
    // so a smaller fontsize may be appropriate.
    fontSize: 14,
    fontWeightBold: 700,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    fontWeightLight: 300,
    fontWeight: 400,
    h1: {
      fontSize: 50,
      fontWeight: 700,
    },
    h2: {
      fontSize: 45,
      fontWeight: 700,
    },
    h3: {
      fontSize: 40,
      fontWeight: 700,
    },
    h4: {
      fontSize: 35,
      fontWeight: 700,
    },
    h5: {
      fontSize: 30,
      fontWeight: 700,
    },
    h6: {
      fontSize: 25,
      fontWeight: 700,
    },
  },
  palette: {
    appBar: {
      main: "rgba(250,250,250)",
    },
    primary: {
      main: "#4D8962",
    },
    secondary: {
      main: "#6E6E70",
    },
  },
});

theme = responsiveFontSizes(theme);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
